export default __webpack_public_path__ + "static/media/card_outline.1a3e6757.svg";